import { IBeforeWinAnimationConfiguration } from '@GFTypes/GameStoreTypes';

export const BEFORE_WIN_ANIMATION_CONFIGURATION_DEFAULTS: IBeforeWinAnimationConfiguration = {
    loopDuration: 1000
};
